((scope) => {
  "use strict";

  const SAFE_ID = /^[a-zA-Z0-9][a-zA-Z0-9_-]{0,159}$/;

  function requiredId(value, field) {
    if (typeof value !== "string" || !SAFE_ID.test(value)) {
      throw new Error(`invalid_${field}`);
    }
    return value;
  }

  function requiredNumber(value, field, min, max) {
    const number = typeof value === "number" ? value : Number(value);
    if (!Number.isFinite(number) || number < min || number > max) {
      throw new Error(`invalid_${field}`);
    }
    return Object.is(number, -0) ? 0 : number;
  }

  function requiredArtworkUrl(value) {
    if (typeof value !== "string" || !value || value.length > 2048) {
      throw new Error("invalid_artwork");
    }
    const url = new URL(value);
    if (url.protocol !== "https:" || url.username || url.password) {
      throw new Error("invalid_artwork");
    }
    return url.toString();
  }

  function approvedEndpoint(backendEndpoint, pageUrl) {
    const backend = new URL(backendEndpoint, pageUrl);
    const loopback = backend.protocol === "http:"
      && ["127.0.0.1", "localhost", "[::1]"].includes(backend.hostname);
    if ((backend.protocol !== "https:" && !loopback) || backend.username || backend.password) {
      throw new Error("invalid_backend_endpoint");
    }
    return new URL("/api/magic-preview/approved-preview", backend.origin);
  }

  function buildApprovedPreviewUrl(input) {
    if (!input || typeof input !== "object" || Array.isArray(input)) {
      throw new Error("invalid_approved_preview_input");
    }
    const url = approvedEndpoint(input.backend_endpoint, input.page_url);
    url.searchParams.set("product_id", requiredId(input.product_id, "product_id"));
    url.searchParams.set("colour_id", requiredId(input.colour_id, "colour_id"));
    url.searchParams.set("artwork", requiredArtworkUrl(input.artwork));
    url.searchParams.set("offset_x", String(requiredNumber(input.offset_x, "offset_x", -1, 1)));
    url.searchParams.set("offset_y", String(requiredNumber(input.offset_y, "offset_y", -1, 1)));
    url.searchParams.set("scale", String(requiredNumber(input.scale, "scale", 0.55, 1)));
    return url.toString();
  }

  scope.SpiritInkMagicPreviewApprovedPreview = Object.freeze({ buildApprovedPreviewUrl });
})(typeof window === "undefined" ? globalThis : window);
